import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  TextField,
  Checkbox,
} from "@material-ui/core";
import ReviewAgentIcon from "../../Svg/ReviewAgentIcon";
import {
  PencilLine,
  X,
  Trash,
  Check,
  Warning,
  CaretRight,
} from "phosphor-react";
import useStyles from "./ReviewAgentModal.styles";
import { fpost } from "../../../../API/callsAPI";
import CustomLoader from "../../Loader/CustomLoader";
import ErrorCharacter from "../../Svg/ErrorCharacterSvg";
import _ from "lodash";
import ToDoTaskUpdation from "./ToDoTaskUpdation";

export default function ReviewAgentModal({
  trackableType,
  versionId,
  handleClose,
  selectedComments,
}) {
  const classes = useStyles();
  const [isCheckListGenInProgress, setIsCheckListGenInProgress] =
    useState(false);
  const [generatedCheckListItems, setGeneratedCheckListItems] = useState([]);
  const [showError, setShowError] = useState(false);
  const [updateTaskModal, setUpdateTaskModal] = useState(false);
  const [currentStep, setCurrentStep] = useState("1");
  const [trackableTaskList, setTrackableTaskList] = useState([]); //state for task lists

  async function generateCheckList() {
    try {
      // api call to backend to generate checklist using agent
      setIsCheckListGenInProgress(true);
      const dataObj = {
        version_type: trackableType,
        version_id: versionId,
      };
      if (selectedComments.length > 0) {
        dataObj["comment_ids"] = selectedComments;
      }

      // TODO make payload dynamic
      const checkListGenResponse = await fpost({
        url: "trackables/generate-checklist/",
        data: dataObj,
      });

      if (checkListGenResponse.status === 200) {
        // set the list of generated checklists Items
        if (
          checkListGenResponse.data.generatedCheckList &&
          checkListGenResponse.data.taskList
        ) {
          setGeneratedCheckListItems(
            checkListGenResponse.data.generatedCheckList
          );
          // set the list of all task for the dropdown
          setTrackableTaskList(checkListGenResponse.data.taskList);
        }
        // set progress to false
        setIsCheckListGenInProgress(false);
      }
    } catch (error) {
      console.log("Error in generating checklist", error);
      setShowError(true);
      setIsCheckListGenInProgress(false);
    }
  }

  const bulkAddCheckListItems = async () => {
    const finalCheckListArray = [];
    generatedCheckListItems.forEach((listItem) => {
      if (!_.isEmpty(listItem.taskData) && listItem.taskData.id !== "none") {
        const obj = { title: listItem.taskName, task: listItem.taskData.id };
        finalCheckListArray.push(obj);
      }
    });
    try {
      const res = await fpost({
        url: `trackables/checklist-items/`,
        data: finalCheckListArray,
      });
      handleClose();
    } catch (error) {
      console.log("Error in generating checklist", error);
    }
  };

  useEffect(() => {
    // after the modal is loaded, wait for 2 seconds and then set then start the checklist generation.
    generateCheckList();
    return () => {};
  }, []);

  function createTaskShotMapping(generatedTaskList, taskList) {
    const taskIdCountMap = {}; //holds count of occurrences of taskData.id in generatedTaskList

    for (const task of generatedTaskList) {
      const taskId = task.taskData.id;
      if (taskIdCountMap[taskId]) {
        taskIdCountMap[taskId]++;
      } else {
        taskIdCountMap[taskId] = 1;
      }
    }

    const taskShotMapping = []; //holds the final array with taskId, shotId, and count

    //Loop through taskIdCountMap and find matching tasks in taskList
    for (const taskId in taskIdCountMap) {
      const numericTaskId = parseInt(taskId, 10);

      // Find the corresponding task in taskList by id
      const matchingTask = taskList.find((task) => task.id === numericTaskId);

      // If a matching task is found, add to the final mapping
      if (matchingTask) {
        taskShotMapping.push({
          taskId: matchingTask.id,
          shotId: matchingTask.linked,
          totalNewTodo: taskIdCountMap[taskId],
          llmDifficultyPrediction: 6,
          weight1: 0.2,
          weight2: 0.2,
          baseTime: 1,
          parentPhaseDifficulty: 5,
        });
      }
    }

    return taskShotMapping;
  }

  const getTaskUpdatedDates = async () => {
    const selectedTasks = createTaskShotMapping(
      generatedCheckListItems,
      trackableTaskList
    );
    let obj1 = {};
    selectedTasks.forEach((task) => {
      obj1[task.taskId] = task;
    });
    let obj = {};
    obj["taskList"] = obj1;
    console.log("this here", obj);
    try {
      const res = await fpost({
        url: `trackables/generate-estimated-time/`,
        data: obj,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box className={classes.root}>
      <div className={classes.spaceBetween}>
        <div className={classes.header}>
          <ReviewAgentIcon />
          <Typography className={classes.heading}>New To Do’s</Typography>
        </div>
        <Button onClick={handleClose}>
          <X size={22} />
        </Button>
      </div>
      {currentStep === "1" && (
        <Box>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginLeft: "-10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Checkbox
                checked={updateTaskModal}
                onChange={(e) => setUpdateTaskModal(e.target.checked)}
              />
              <Typography>Add To Do’s & update Tasks</Typography>
            </div>
            <Typography>
              <span className={classes.greyText}>New To Do’s</span> :{" "}
              {generatedCheckListItems.length}
            </Typography>
          </Box>
          {!isCheckListGenInProgress ? (
            showError ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <ErrorCharacter />
                <div
                  style={{
                    position: "absolute",
                    width: "200px",
                    left: "43%",
                    color: "black",
                    top: "12%",
                  }}
                >
                  <Typography className={classes.warningTextHeader}>
                    Oops! <Warning weight="fill" size={22} color="#FF9800" />
                  </Typography>
                  Seems like we ran into an issue while generating your To Do’s!
                </div>
              </div>
            ) : (
              <div className={classes.listContainer}>
                {generatedCheckListItems.map((item) => {
                  return (
                    <SingleToDo
                      singleCheckList={item}
                      taskList={trackableTaskList}
                      onTaskChange={(updatedTaskId, listItem) => {
                        // TODO improve this logic. This is not the best way to update the task id in the object of generatedCheckListItems
                        // update the task id in the object of generatedCheckListItems
                        const reGneratedCheckList = generatedCheckListItems.map(
                          (checkListItem) => {
                            if (
                              checkListItem.description === listItem.description
                            ) {
                              checkListItem.taskData.id = updatedTaskId;
                            }
                            return checkListItem;
                          }
                        );
                        // set the state of generatedCheckListItems
                        setGeneratedCheckListItems(reGneratedCheckList);
                      }}
                      onTextUpdate={(text, listItem) => {
                        // update the text in the object of generatedCheckListItems
                        const reGneratedCheckList = generatedCheckListItems.map(
                          (checkListItem) => {
                            if (
                              checkListItem.description === listItem.description
                            ) {
                              checkListItem.taskName = text;
                            }
                            return checkListItem;
                          }
                        );
                        // set the state of generatedCheckListItems
                        setGeneratedCheckListItems(reGneratedCheckList);
                      }}
                      onRemoveTask={(listItem) => {
                        const reGneratedCheckList =
                          generatedCheckListItems.filter(
                            (checkListItem) =>
                              checkListItem.description !== listItem.description
                          );
                        setGeneratedCheckListItems(reGneratedCheckList);
                      }}
                    />
                  );
                })}
              </div>
            )
          ) : (
            <CustomLoader
              customLoaderText={
                "Please, give us a few seconds while we review your comments and get your To Do’s ready!"
              }
            />
          )}
          <div className={classes.btnContainer}>
            <Button
              disabled={!updateTaskModal || isCheckListGenInProgress}
              onClick={() => {
                getTaskUpdatedDates();
                setCurrentStep("2");
              }}
              className={classes.submitButton}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                Continue to Task Updation <CaretRight size={20} />
              </div>
            </Button>
            {showError ? (
              <Button
                className={classes.submitButton}
                onClick={() => {
                  setShowError(false);
                  generateCheckList();
                }}
              >
                Retry Generation
              </Button>
            ) : (
              <Button
                disabled={isCheckListGenInProgress || updateTaskModal}
                className={classes.submitButton}
                onClick={bulkAddCheckListItems}
              >
                Add To Do's
              </Button>
            )}
          </div>
        </Box>
      )}
      {currentStep === "2" && (
        <ToDoTaskUpdation goBack={() => setCurrentStep("1")} />
      )}
    </Box>
  );
}

const SingleToDo = ({
  singleCheckList,
  taskList,
  onTextUpdate,
  onTaskChange,
  onRemoveTask,
}) => {
  const classes = useStyles();
  const [text, setText] = useState(
    singleCheckList.taskName ? singleCheckList.taskName : ""
  );
  const [isEditing, setEditing] = useState(false);

  const handleEditing = () => {
    setEditing(!isEditing);
  };
  function handleKeyDown(event) {
    event.stopPropagation();
  }

  return (
    <div>
      <Box>
        <div className={classes.spaceBetween} onKeyDown={handleKeyDown}>
          {isEditing ? (
            <TextField
              InputProps={{ disableUnderline: true }}
              style={{ fontSize: "14px !important", width: "470px" }}
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          ) : (
            <Typography style={{ fontSize: "14px !important" }}>
              {singleCheckList.taskName}
            </Typography>
          )}
          <div>
            {isEditing ? (
              <Button
                onClick={() => {
                  handleEditing();
                  onTextUpdate(text, singleCheckList);
                }}
              >
                <Check size={18} />
              </Button>
            ) : (
              <Button onClick={handleEditing}>
                <PencilLine size={18} />
              </Button>
            )}
            {isEditing ? (
              <Button
                onClick={() => {
                  handleEditing();
                  setText(singleCheckList.taskName);
                }}
              >
                <X color="#F40A0A" size={18} />
              </Button>
            ) : (
              <Button onClick={() => onRemoveTask(singleCheckList)}>
                <Trash color="#F40A0A" size={18} />
              </Button>
            )}
          </div>
        </div>
      </Box>
      <div className={classes.spaceBetween}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div className={classes.pointer} />
          <Select
            disableUnderline={true}
            value={singleCheckList.taskData.id || 0}
            className={classes.select}
            onChange={(event) => {
              onTaskChange(event.target.value, singleCheckList);
            }}
          >
            {taskList.map((task) => {
              return (
                <MenuItem key={task.id} value={task.id}>
                  {task.name}
                </MenuItem>
              );
            })}
            <MenuItem value={"none"}>None</MenuItem>
          </Select>
        </div>
        {/* {isEditing ? (
          <div className={classes.spaceBetween}>
            <Checkbox />
            <Typography>Link Version</Typography>
          </div>
        ) : (
          <div className={classes.spaceBetween}>
            <Warning />
            <Typography>Colosses.v01</Typography>
          </div>
        )} */}
      </div>
    </div>
  );
};
